<template>
    <td class="vrm-table__nowrap">
        <vrm-avatar :user="user" :admin-key="adminKey" />
        {{ user.name }}
    </td>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import VrmAvatar from '@/vue/components/shared/VrmAvatar';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component({
    components: {
        VrmAvatar,
    },
})
@AngularDirective('vrm-table-cell-user')
export default class VrmTableCellUser extends Vue {
    @Prop({ type: Object, default: null })
    user;
    @Prop({ type: String, default: undefined })
    adminKey;
}
</script>
